var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['sub-header', _vm.isUserFromAPP && 'app-layout_sub-header'],attrs:{"id":"SubHeader"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }